import { useOfflineStatus } from '../../context/OfflineProvider';
import './OfflineStatusBanner.css';

export default function OfflineStatusBanner() {
  const { online, pending, syncing, retry } = useOfflineStatus();

  if (online && pending <= 0 && !syncing) return null;

  let label = 'Synced';
  if (!online) label = pending > 0 ? `Offline · ${pending} pending sync` : 'Offline';
  else if (syncing) label = pending > 0 ? `Syncing ${pending}…` : 'Syncing…';
  else if (pending > 0) label = `${pending} pending sync`;

  return (
    <div className={`offline-status-banner${online ? '' : ' is-offline'}`} role="status">
      <span>{label}</span>
      {online && pending > 0 ? (
        <button type="button" className="offline-status-retry" onClick={retry} disabled={syncing}>
          Retry
        </button>
      ) : null}
    </div>
  );
}
